// src/components/Footer.jsx
import React from "react";
import { useLocation } from "react-router-dom";
import "./Footer.css";

import tiktok from "../assets/tiktok.avif";
import instagram from "../assets/instagram.avif";
import youTube from "../assets/youtube.avif";
import facebook from "../assets/facebook.avif";
import spotify from "../assets/spotify.avif";

export default function Footer() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;

  const year = new Date().getFullYear();

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-wrap">
        <div className="footer-grid">
          {/* Coluna 1 — Contato */}
          <section className="col" aria-labelledby="ft-contato">
            <h2 id="ft-contato" className="title">Contato</h2>
            <div className="contact">
              <p className="line line--mail">
                <a className="link" href="mailto:info@lucianacosta.cv">
                  info@lucianacosta.cv
                </a>
              </p>
              <p className="line line--phone">
                <a className="link" href="tel:+2389117579">
                  (+238) 911 7579
                </a>
              </p>
              <p>
                WhatsApp:&nbsp;
                <a
                  className="link"
                  href="https://wa.me/2389394185"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  (+238) 939 4185
                </a>
              </p>
            </div>
          </section>

          {/* Coluna 2 — Endereço & Horário */}
          <section className="col" aria-labelledby="ft-endereco">
            <h2 id="ft-endereco" className="title">Endereço &amp; Horário</h2>
            <address className="address">
              <p className="line line--map">Achada Santo António, 10</p>
              <p className="line">Praia, Cabo Verde, CP 154C</p>
              <p className="line line--calendar">Segunda a Sexta: 9h às 17h</p>
              <p className="line">Sábado e Domingo: Fechado</p>
            </address>

            <ul className="legal">


              <li><a className="link" href="/politica-entrega">Política de Entrega e Devolução</a></li>
              <li><a className="link" href="/politica-de-privacidade">Política de Privacidade</a></li>
              <li><a className="link" href="/politica-de-cookies">Política de Cookies</a></li>
              {/* Usa a rota exatamente como está no App.jsx */}
              <li><a className="link" href="/TermosCondicoes">Termos e Condições</a></li>
              <li><a className="link" href="/eliminar-dados">Eliminar Dados (Data Deletion)</a></li>

              {/* <li>
                <button
                  type="button"
                  className="link btn-as-link"
                  onClick={() => window.dispatchEvent(new CustomEvent("open-cookie-consent"))}
                  aria-controls="cookie-consent"
                >
                  Gerir cookies
                </button>
              </li> */}
            </ul>
          </section>

          {/* Coluna 3 — Redes Sociais + Pagamentos */}
          <section className="col" aria-labelledby="ft-sociais">
            <h2 id="ft-sociais" className="title">Siga as Redes Sociais</h2>

            <nav className="social" aria-label="Redes sociais">
              <a href="#" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
                <img src={tiktok} alt="TikTok" loading="lazy" decoding="async" />
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <img src={facebook} alt="Facebook" loading="lazy" decoding="async" />
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Spotify">
                <img src={spotify} alt="Spotify" loading="lazy" decoding="async" />
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <img src={instagram} alt="Instagram" loading="lazy" decoding="async" />
              </a>
              <a
                href="https://www.youtube.com/@Espiritualismonovaerapav"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
              >
                <img src={youTube} alt="YouTube" loading="lazy" decoding="async" />
              </a>
            </nav>

            <div className="payments" aria-labelledby="ft-pagamentos">
              <h3 id="ft-pagamentos" className="payments-title">Métodos de Pagamento</h3>
              <div className="payment-logos" aria-label="Logotipos de métodos de pagamento">
                <img
                  className="brand"
                  src="/img/visa-secure_blu_2021_dkbg.png"
                  alt="Visa Secure"
                  loading="lazy"
                  decoding="async"
                />
                <img
                  className="brand"
                  src="/img/mc_idcheck_hrz_rgb_rev.png"
                  alt="Mastercard ID Check"
                  loading="lazy"
                  decoding="async"
                />
                <img
                  className="brand"
                  src="/img/vinti4.png"
                  alt="Vinti4"
                  loading="lazy"
                  decoding="async"
                />
                <img
                  className="brand"
                  src="/img/amex_SK_logo_full.png"
                  alt="American Express"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <p className="payments-merchant">
                Pagamentos processados por <strong>MIT Solutions, Lda</strong> (NIF 284004405).
              </p>
            </div>

            <div className="copyright">
              <p>©{year} por Luciana Costa — Todos os direitos reservados</p>
              <p>Terapias Holística Mãos de Luz, Lda. — NIF 200492918</p>
            </div>
          </section>
        </div>

        <div className="disclaimer">
          Este website é operado por <strong>MIT Solutions, Lda</strong> (NIF 284004405).
          A marca <strong>Luciana Costa</strong> é propriedade de <strong>Terapias Holística Mãos de Luz, Lda</strong> (NIF 200492918).
          Todos os pagamentos são processados de forma segura através do <strong>SISP/Vinti4</strong>.
        </div>
      </div>
    </footer>
  );
}

